import { Box, darken, Typography } from "@mui/material"
import { Button } from "components"
import { IoCloseCircleOutline } from "react-icons/io5"
import { styled } from "@mui/styles"

interface Props {
  title?: string
  handleClose: () => void
  handleSend?: () => Promise<void> | void
}

const BoxError = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}))

const Message = styled(Typography)(({ theme }) => ({
  fontFamily: "Inter",
  fontWeight: 500,
  fontSize: "1rem",
  lineHeight: "1rem",
  color: "#353535",
  margin: "1rem 0 2.5rem",
}))

const BoxButtons = styled(Box)(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
}))

const Btn = styled(Button)(({ theme }) => ({
  padding: "1rem 2.6rem",
  background: "#618619",
}))

const BtnClose = styled(Button)(({ theme }) => ({
  width: "8.3rem",
  height: "3.1rem",
  background: "#FFFFFF",
  color: "#757575",
  border: "1px solid #C4C4C4",
  boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.05)",
  marginTop: "1rem",
  "&:hover": {
    background: darken("#FFFFFF", 0.02),
  },
}))

export const Error = (props: Props) => {
  const { title, handleSend, handleClose } = props

  return (
    <Box>
      <BoxError>
        <IoCloseCircleOutline size="4.5rem" color="#DA3737" />
        <Message variant="subtitle1">{title}</Message>
      </BoxError>
      <BoxButtons>
        <Btn type="submit" onClick={handleSend}>
          Tentar novamente
        </Btn>
        <BtnClose type="submit" onClick={handleClose}>
          Fechar
        </BtnClose>
      </BoxButtons>
    </Box>
  )
}
